import React from 'react';
import { BottomNavigation } from './BottomNavigation';
import { DesktopSidebar } from '../DesktopSidebar/DesktopSidebar';
import { useShouldShowNav } from '../../../hooks';
import styled from 'styled-components';

// Wrapper to ensure consistent BottomNavigation appearance across all pages
const NavigationWrapper = styled.div`
  /* Reset any inherited styles that might affect the navigation */
  position: relative;
  z-index: 1000;

  /* Ensure the navigation is always on top */
  * {
    box-sizing: border-box;
  }

  /* Override any page-specific styles that might interfere */
  button {
    font-family: inherit;
  }
`;

interface BottomNavigationWrapperProps {
  isVisible?: boolean;
  onSwipeModeToggle?: (enabled: boolean) => void;
}

export const BottomNavigationWrapper: React.FC<BottomNavigationWrapperProps> = React.memo(({
  isVisible: propIsVisible,
  onSwipeModeToggle
}) => {
  const shouldShow = useShouldShowNav(propIsVisible);

  return (
    <NavigationWrapper>
      <BottomNavigation
        isVisible={shouldShow}
        onSwipeModeToggle={onSwipeModeToggle}
      />
      <DesktopSidebar
        isVisible={shouldShow}
        onSwipeModeToggle={onSwipeModeToggle}
      />
    </NavigationWrapper>
  );
});

BottomNavigationWrapper.displayName = 'BottomNavigationWrapper';
